module.exports = __webpack_public_path__ + "img/borderWavesBlue.998c41ae.svg";